<!-- Main Page Start -->
<div class="content-wrapper table-full-bx details-page">
    <div class="page-content recruiterpanel">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox">
                    <div class="ibox-body">
                        <div class="page-heading slash_breadcrumb">
                            <ol class="breadcrumb ">
                                <li class="breadcrumb-item"><a routerLink="/groups"> Groups and Permissions </a></li>
                                <li class="breadcrumb-item"> Add a New Group </li>
                            </ol>
                        </div> 
                        <div class="ibox-title">
                            <span> Add a New Group </span>
                        </div>
                        <div class="col-bx-top">
                            <form [formGroup]="groupForm">
                                <div class="form-group">
                                    <label>Name of the group <span class="text-orange">*</span> </label>
                                    <input class="form-control" type="text" placeholder="Hr Manager" formControlName="groupName" appCapitalizeFirst/>
                                    <div class="text-danger" *ngIf="groupForm.controls['groupName'].hasError('required') && showError">
                                        *Please enter group name.
                                    </div>
                                    <div class="text-danger" *ngIf="groupForm.controls['groupName'].hasError('minlength') && showError">
                                        *Minimum 3 characters required.
                                    </div>
                                    <div class="text-danger" *ngIf="groupForm.controls['groupName'].hasError('maxlength') && showError">
                                        *Maximum 30 characters required.
                                    </div>
                                    <div class="text-danger" 
                                        *ngIf="!groupForm.controls['groupName'].hasError('required') && 
                                            !groupForm.controls['groupName'].hasError('minlength') && 
                                            !groupForm.controls['groupName'].hasError('maxlength') && 
                                            groupForm.controls['groupName'].hasError('cannotContainSpace') && showError">
                                        *Invalid characters.
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label> Group’s description <span class="text-orange">*</span> </label>
                                    <textarea class="form-control" type="text" formControlName="groupDescription" maxlength="250" appCapitalizeFirst placeholder="This article is about ground-warfare militaries. For the large military."></textarea>
                                    <span class="input-count">{{groupForm?.value?.groupDescription?.length}}/250</span>    
                                    <div class="text-danger" *ngIf="groupForm.controls['groupDescription'].hasError('required') && showError">
                                        *Please enter group description.
                                    </div>
                                    <div class="text-danger" *ngIf="groupForm.controls['groupDescription'].hasError('minlength') && showError">
                                        *Minimum 3 characters required.
                                    </div>
                                    <div class="text-danger" *ngIf="groupForm.controls['groupDescription'].hasError('maxlength') && showError">
                                        *Maximum 250 characters required.
                                    </div>
                                    <div class="text-danger" 
                                        *ngIf="!groupForm.controls['groupDescription'].hasError('required') && 
                                            !groupForm.controls['groupDescription'].hasError('minlength') && 
                                            !groupForm.controls['groupDescription'].hasError('maxlength') && 
                                            groupForm.controls['groupDescription'].hasError('cannotContainSpace') && showError">
                                        *Invalid characters.
                                    </div>
                                </div>
                                <div class="add-permissions">
                                    <div class="ibox-title">
                                        <span> Permissions </span>
                                    </div>
                                    <div class="jobswrap" *ngFor="let access of accessList; let i=index">
                                        <h6 class="sub_title"> {{access?.name}} </h6>
                                        <div class="row">
                                            <div class="col-lg-6" *ngFor="let acc of access?.placeholder; let j = index">
                                                <div class="checkboxWrap" (click)="clickEvent(i,j)">
                                                    <input type="checkbox" 
                                                    [checked]="acc?.permission == 1 ? true : false"
                                                     /> 
                                                    <label for="jobs1">{{acc.title}}</label>
                                                </div>
                                            </div>
                                         </div>
                                    </div>
                                </div>
                            </form>
                            <div class="form-group btnwrap">
                                <input value="Cancel" name="" class="common-btn unfill" type="submit" routerLink="/groups"/>
                                <input value="Save" name="" class="common-btn" type="submit" (click)="submitGroup()"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End -->